/**
 * @author Kelnik
 *
 * ParametricPagination - Пагинация для параметрического
 */

import History from 'components/history';
import Utils from 'common/scripts/utils';

class ParametricPagination {
    constructor(options) {
        this.options = options;
        this.containerSelector = '.j-parametric-pagination';
        this.container = document.querySelector(this.containerSelector);
        this.listWrapSelector = '.j-parametric-pagination-list-wrap';
        this.listSelector = '.j-parametric-pagination-list';

        this.prevSelector = '.j-parametric-pagination-prev';
        this.nextSelector = '.j-parametric-pagination-next';
        this.pageSelector = '.j-parametric-pagination-page';

        this.current = History.get('page') || 1;
        this.lastPage = 1;
        this.stepItems = 2;
        this.stepScroll = 0;

        this.init();
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._bindEvents();
    }

    _initElements() {
        this.listWrap = this.container.querySelector(this.listWrapSelector);
        this.list = this.container.querySelector(this.listSelector);
        this.prev = this.container.querySelector(this.prevSelector);
        this.next = this.container.querySelector(this.nextSelector);
        this.pages = Array.from(this.container.querySelectorAll(this.pageSelector));

        this.lastPage = this.pages.length;
    }

    _bindEvents() {
        this.prev.addEventListener('click', this._prevPage.bind(this));
        this.next.addEventListener('click', this._nextPage.bind(this));

        this.pages.forEach((page) => {
            page.addEventListener('click', (event) => {
                event.preventDefault();

                if (page.classList.contains('is-active')) {
                    return;
                }

                this.current = page.dataset.page;

                this._setPage();
            });
        });

        window.addEventListener('resize', Utils.debounce(this._setScrollList.bind(this), 500));
    }

    _nextPage() {
        this.stepScroll = this.stepScroll + 1;

        this._setScrollList();
    }

    _prevPage() {
        this.stepScroll = this.stepScroll - 1;

        this._setScrollList();
    }

    _setScrollList() {
        const widthItem = this._getWidthItemPage();
        const marginRight = this._getMarginRightItemPage();
        const stepPx = (widthItem + marginRight) * this.stepItems * this.stepScroll;
        const max = this.list.scrollWidth - this.listWrap.offsetWidth;

        this.list.style.transform = `translateX(-${stepPx}px)`;

        this._checkDisabled(stepPx, max);
    }

    _getWidthItemPage() {
        return this.pages.length ? this.pages[0].offsetWidth : 0;
    }

    _getMarginRightItemPage() {
        if (!this.pages.length) {
            return 0;
        }

        const marginRight = window.getComputedStyle(this.pages[0]).getPropertyValue('margin-right');

        return parseInt(marginRight, 10);
    }

    _setPage(pageEl = null) {
        const currentEl = pageEl || this.pages.find((page) => {
            return Number(page.dataset.page) === Number(this.current);
        });

        this._setActivePage(currentEl);

        History.append('page', this.current);

        if (this.options.afterChange) {
            this.options.afterChange();
        }
    }

    _checkDisabled(stepPx, max) {
        if (this.stepScroll < 0) {
            this.stepScroll = 0;
        }

        if (this.stepScroll > this.pages.length) {
            this.stepScroll = this.pages.length;
        }

        if (stepPx >= max) {
            this._disabledNext();
        } else {
            this._enabledNext();
        }

        if (stepPx <= 0) {
            this._disabledPrev();
        } else {
            this._enabledPrev();
        }
    }

    _setActivePage(page) {
        this.pages.forEach((item) => {
            if (page === item) {
                item.classList.add('is-active');
            } else {
                item.classList.remove('is-active');
            }
        });
    }

    _disabledPrev() {
        this.prev.classList.add('is-disabled');
    }

    _enabledPrev() {
        this.prev.classList.remove('is-disabled');
    }

    _disabledNext() {
        this.next.classList.add('is-disabled');
    }

    _enabledNext() {
        this.next.classList.remove('is-disabled');
    }
}

export default ParametricPagination;
